import { atom, useAtomValue } from 'jotai'

import type { AutomationSimulation } from './useAutomationSimulation'

export const DEFAULT_SIMULATION_STATE: AutomationSimulation = {
  analysis: undefined,
  result: undefined,
  isPending: false,
  isLoadingAutomation: false,
  isResolvingDependencies: false,
  isEvaluating: false,
  refetchDependencies: async () => {}
}

export const simulationStateAtom = atom<AutomationSimulation>(
  DEFAULT_SIMULATION_STATE
)

export const useAutomationSimulationContext = (): AutomationSimulation =>
  useAtomValue(simulationStateAtom)
